import Select from './Select';
import SelectNode from './SelectNode';

export { SHOW_ALL, SHOW_CHILD, SHOW_PARENT } from './strategies';
export var TreeNode = SelectNode;

export default Select;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-tree-select/src/index.js
// module id = 382
// module chunks = 0